import { Session } from "@/framework/types/Session";

export default {
  navigation(state: any): any {
    return state.navigation;
  },
  appMode(state: any): any {
    return state.appMode;
  },
  isEnableKtznLang(state: any): boolean {
    return state.isEnableKtznLang;
  },
  isWeChat(state: any): boolean {
    return state.isWeChat;
  },
  isLoading(state: any): boolean {
    return state.isLoading;
  },
  isSaving(state: any): boolean {
    return state.isSaving;
  },
  closePrivacyPolicyFooter(state: any): boolean {
    return state.closePrivacyPolicyFooter;
  },
  session(state: any): Session {
    return state.session;
  },
  recievedEventIdList(state: any): number[] {
    return state.recievedEventIdList;
  },
  isFromLogin(state: any): Session {
    return state.isFromLogin;
  },
  isRedirected(state: any): Session {
    return state.isRedirected;
  },
  checkNotificationPermission(state: any): any {
    return state.checkNotificationPermission;
  },
  guestHideHomeIcon(state: any): any {
    return state.guestHideHomeIcon;
  },
};
